import Text from 'shopper/components/Text';

import Image from 'components/Image';

import placeholder from 'lib/placeholder';

import APP from 'constants/app';

const QrCode = () => (
  <div className="flex size-40 flex-col items-center justify-center rounded-3 bg-neutral-high-100 py-3">
    <Text
      className="mb-1 text-neutral-low-400 dark:text-neutral-low-400"
      size="size2"
      bold
    >
      {placeholder('subtitles.qrCode')}
    </Text>
    <Image
      alt="QR code para poder baixar o app em seu smartphone"
      className="mx-auto my-4 block"
      height={96}
      src={`${APP.LOCAL_IMAGE_PATH}/features/landings/qr-code.svg`}
      width={96}
    />
  </div>
);

export default QrCode;
